import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const Problem = () => {
  const { t } = useLang();
  const cards = t("problem.cards");
  return (
    <section className="relative py-32 lg:py-48 bg-[#081328]" data-testid="problem-section">
      <div className="container-sat grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="overline mb-6">{t("problem.overline")}</div>
          <h2 className="headline-xl text-4xl md:text-5xl lg:text-6xl">
            {t("problem.title")}
          </h2>
        </div>
        <div className="lg:col-span-7 lg:pt-4">
          <p className="serif text-2xl md:text-3xl leading-relaxed font-light text-white/80">
            {t("problem.paragraph")}
          </p>

          <div className="mt-12 grid sm:grid-cols-2 gap-4" data-testid="problem-cards">
            {cards.map((c, i) => (
              <div key={i} className="glass rounded-2xl p-6 hover:bg-white/[0.04] transition" data-testid={`problem-card-${i}`}>
                <div className="flex items-baseline gap-3 mb-3">
                  <span className="num-mark">0{i + 1}</span>
                  <span className="text-xs uppercase tracking-widest text-white/40">·</span>
                </div>
                <div className="serif text-2xl text-white">{c.t}</div>
                <div className="text-white/55 mt-2">{c.d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
